module.exports = __webpack_public_path__ + "static/media/img2.ab624d85.jpg";